import React from "react";
import { types, Text } from "react-bricks/frontend";
import { Input, SelectInput, MultiSelectInput, TextArea } from "components/atoms/Form";

export interface HubspotFormFieldProps {
  label: string;
  type: "text" | "phone" | "email" | "select" | "multiselect" | "textarea";
  maxLength?: number;
  options?: { label: string; value: string }[];
  name: string;
  isRequired?: boolean;
}

const HubspotFormField: types.Brick<HubspotFormFieldProps> = ({
  type,
  name,
  label,
  options = [],
  maxLength,
  isRequired,
}) => {
  switch (type) {
    case "text":
    case "email":
      return <Input name={name} placeholder={label} type="text" isRequired={isRequired} />;
    case "phone":
      return <Input name={name} placeholder={label} type="phone" isRequired={isRequired} />;
    case "select":
      return (
        <SelectInput
          name={name}
          placeholder={label}
          options={options.map((o) => o.value)}
          required={isRequired}
        />
      );
    case "multiselect":
      return (
        <MultiSelectInput
          name={name}
          placeholder={label}
          options={options.map((o) => ({ id: o.value, name: o.label }))}
          required={isRequired}
        />
      );
    case "textarea":
      return (
        <TextArea name={name} placeholder={label} maxLength={maxLength} isRequired={isRequired} />
      );
    default:
      return null;
  }
};

HubspotFormField.schema = {
  // Unique brick name
  name: "hubspot-form-field",
  label: "HubspotFormField",
  hideFromAddMenu: true,
  // Defaults when a new brick is added
  getDefaultProps: () => ({
    type: "text",
    label: "First Name",
    name: "firstname",
  }),

  // Sidebar Edit controls for props
  sideEditProps: [
    {
      name: "name",
      label: "Name (for Hubspot)",
      type: types.SideEditPropType.Text,
    },
    {
      name: "label",
      label: "Label",
      type: types.SideEditPropType.Text,
    },
    {
      name: "type",
      label: "Type",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Radio,
        options: [
          { label: "Text", value: "text" },
          { label: "Text Area", value: "textarea" },
          { label: "Phone number", value: "phone" },
          { label: "Select", value: "select" },
          { label: "Multi-select", value: "multiselect" },
        ],
      },
    },
    {
      name: "isRequired",
      label: "Required?",
      type: types.SideEditPropType.Boolean,
    },
    {
      name: "options",
      label: "Options (1 per line)",
      type: types.SideEditPropType.Textarea,
    },
  ],
};

export default HubspotFormField;
